import { axios } from "@Root/API";

export const getPostgradStudentSelectOptions = () => {
  return axios.get("get-data-for-index-post-grad");
};
